<template>
  <v-container fluid grid-list-md>
    <v-layout row justify-center align-center>
      <v-flex md8 xs12>
        <v-card>
          <card-toolbar title="Özel Excel İle Whatsapp Mesajı Gönder"></card-toolbar>
          <div style="padding: 15px;" v-if="!whatsappStatus">
            <v-alert type="warning">Whatsapp numaranız aktif değil. <a href="/whatsapp/settings" style="color:#fff">Buraya</a> tıklayarak veya Ayarlar sayfasına giderek numaranızı aktive edebilirsiniz.</v-alert>
          </div>
          <v-card-text>
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1"
                >Excel Dosya Seçimi
                </v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" step="2"
                >Mesajı Hazırla
                </v-stepper-step
                >
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card class="mb-12" height="150">
                    <v-card-text>
                      <v-form ref="stepOne" lazy-validation>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-file-input
                                placeholder="Mesaj gönderilecek Excel dosyanızı seçiniz."
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                v-model="files"
                                :rules="sizeRule"
                                chips
                                required
                                prepend-icon="mdi-paperclip"
                            >
                            </v-file-input>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>
                  </v-card>

                  <v-card-actions>
                    <v-btn color="primary" @click="stepper"> İleri</v-btn>

                    <v-btn text>İptal</v-btn>

                    <ExcelButton type="advanced"></ExcelButton>
                  </v-card-actions>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-card v-if="e1 === 2" class="mb-12">
                    <v-card-text class="pa-0">
                      <v-container fluid grid-list-md>
                        <v-form ref="stepTwo" lazy-validation>
                          <v-layout row wrap>
                            <v-flex md8 xs12>
                              <v-flex xs12>
                                <v-layout row>
                                  <v-flex
                                      grow-shrink-0
                                      v-for="(header,
                                    key) in stepOneResponse.headers"
                                      :key="key"
                                  >
                                    <v-btn
                                        outlined
                                        v-text="header"
                                        @click="messageType(header)"
                                    >
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                                <button-keys
                                    :keys="stepOneResponse.keys"
                                    item-value="value"
                                    @on:button-key="
                                    (val) => {
                                      this.message += ` ${val}`;
                                    }
                                  "
                                >
                                </button-keys>
                              </v-flex>
                              <v-flex v-if="preview">
                                <span v-text="preview"> </span>
                              </v-flex>
                              <v-flex xs12>
                                <whatsapp-message
                                    label="Mesajınız"
                                    :value="message"
                                    :message="message + messageHolder"
                                    :rules="[
                            $rules.empty('Mesaj'),
                            (v) =>{
                              return v.length + messageHolder.length >= 2000 ? 'Maksimum karakter sayısı 2000 olabilir.' : true
                              }
                          ]"
                                    rows="13"
                                    :cMessage="message + messageHolder"
                                    @button:status="(val) => buttonStatus = val"
                                    @text:change="handleTextChange"
                                >
                                </whatsapp-message>
                              </v-flex>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-flex xs12>
                                <v-select
                                    v-model="sendData.phone_colon"
                                    label="Telefon Adı Alanını Seçiniz."
                                    required
                                    :rules="[
                                    $rules.selection('Telefon Adı'),
                                    () =>
                                      !!sendData.phone_colon ||
                                      'Telefon Adı alanı gereklidir.',
                                  ]"
                                    :items="eHeaders"
                                    item-value="k"
                                    item-text="v"
                                >
                                </v-select>
                              </v-flex>
                              <v-flex xs12>
                                <senders
                                    label="Whatsapp Telefon Numarası"
                                    no-data-text="Aktif Gönderici Adı bulunmuyor"
                                    :items="stepOneResponse.senders"
                                    :default="stepOneResponse.senders[0]"
                                    :rules="[
                                    $rules.selection('Gönderici Adları'),
                                  ]"
                                    required
                                    @on:model-update="
                                    (val) => {
                                      sendData.sender = val;
                                    }
                                  "
                                >
                                </senders>
                              </v-flex>
                              <v-flex xs12>
                                <template-selector
                                    label="Şablon Seçinizi"
                                    :items="stepOneResponse.templates"
                                    @on:template-selected="
                                    (val) => {
                                      message = val.content;
                                    }
                                  "
                                >
                                </template-selector>
                              </v-flex>
                              <v-flex xs12>
                                <!-- DELAY SEÇENEĞİ -->
                                <v-select
                                    v-model="delay"
                                    :items="delayOptions"
                                    label="Gönderim Hızı"
                                    required
                                ></v-select>
                              </v-flex>
                              <v-flex xs12>
                                <v-file-input
                                    label="Whatsapp mesajına dosya ekleyebilirsiniz."
                                    placeholder="Whatsapp mesajına eklemek istediğiniz dosyayı seçiniz."
                                    v-model="attachment"
                                    prepend-icon=""
                                    validate-on-blur
                                    @change="handleAttachmentChange"
                                >
                                </v-file-input>
                              </v-flex>
                              <v-flex xs12  v-if="previewUrl">
                                <img :src="previewUrl" alt="Preview" v-if="isImage" style="max-width: 25%;" />
                              </v-flex>
                            </v-flex>
                          </v-layout>
                          <div class="text-right">
                            <whatsapp-confirmation
                                :title="confirmation.title"
                                :context="confirmation.context"
                                :valid="confirmation.valid"
                                @on:disagree="
                                () => {
                                  $trigger('setPluginDialog');
                                  confirmation.valid = !confirmation.valid;
                                }
                              "
                                @on:agree="sendWhatsappS2"
                            >
                              <template v-slot:activator>
                                <v-btn color="primary" @click="whatsappPreview" :disabled="buttonStatus === 'disabled' || !whatsappStatus ? true : false">
                                  Mesajı Gönder
                                  <v-icon right dark>mdi-send</v-icon>
                                </v-btn>
                              </template>
                            </whatsapp-confirmation>
                          </div>
                        </v-form>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';
import { types } from '../../../../misc';
import CardToolbar from '../../../Components/CardToolbar.vue';
import Senders from '../../../Components/WhatsappConstants/Senders.vue';
import WhatsappMessage from '../../../Components/WhatsappConstants/WhatsappMessage.vue';
import ExcelButton from '../../../Components/Whatsapp/ExcelButton.vue';
import ButtonKeys from '../../../Components/WhatsappConstants/ButtonKeys.vue';
import WhatsappConfirmation from '../../../Components/WhatsappConfirmation.vue';
import TemplateSelector from '../../../Components/WhatsappConstants/TemplateSelector.vue';
import checkWebsite from '@/mixins/computed/check-website';

export default {
  name: 'AdvancedExcel',
  components: {
    TemplateSelector,
    WhatsappConfirmation,
    ButtonKeys,
    WhatsappMessage,
    Senders,
    CardToolbar,
    ExcelButton,
  },
  mixins: [checkWebsite],
  data: () => ({
    whatsappStatus: true,
    types,
    e1: 1,
    dateSelected: false,
    preview: '',
    stepOneResponse: [],
    message: '',
    sendData: {
    },
    confirmation: {
      valid: false,
      context: {
        examples: [],
      },
    },
    files: [],
    delayOptions: [
    { text: 'Çok Hızlı (5 saniye de bir)', value: 1 },
      { text: 'Hızlı (10 saniye de bir)', value: 2 },
      { text: 'Orta (20 saniye de bir)', value: 3 },
      { text: 'Yavaş (35 saniye de bir)', value: 4 },
    ],
    delay: null,
    attachment: [],
    previewUrl: null,
    attachmentName: null,
    isImage: false,
    freeze: [],
    sizeRule: [v => v.size > 0 || 'Bir Dosya Yüklemelisiniz!.'],
    senders: [],
    defaultMessage: '',
    defaultLink: '/v/f58d59',
    messageHolder: '',
    buttonStatus: '',
  }),
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    handleAttachmentChange() {
      const file = this.attachment;

      if (file) {
        this.isImage = file.type.startsWith('image/');
        this.previewUrl = this.isImage ? URL.createObjectURL(file) : null;
        this.fileName = file.name;
      } else {
        this.previewUrl = null;
        this.fileName = null;
        this.isImage = false;
      }
    },
    messageType(val) {
      this.message += `|${val}| `;
      let i = null;
      Object.entries(this.stepOneResponse.exampleValues)
          // eslint-disable-next-line array-callback-return
          .filter((el) => {
            if (el[0] === val) {
              i = el[1];
            }
          });
      this.preview += `${i} `;
    },
    stepper() {
      if (this.e1 === 0 || this.e1 === 1) {
        // ilk aşama kontrol ediliyor
        if (this.$refs.stepOne.validate()) {
          this.uploadFileS1();
        }
      } else if (this.$refs.stepTwo.validate()) {
        this.sendWhatsappS2();
      }
    },
    // Aşama 1: Dosya yükleme
    uploadFileS1() {
      const form = new FormData();
      form.append('excel', this.files);
      if (this.$refs.stepOne.validate()) {
        this.send({
          route: 'whatsapp/excel',
          data: form,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(async (res) => {
          this.stepOneResponse = await res.data.data;
          if (this.stepOneResponse.senders === null) {
            this.stepOneResponse.senders = [];
          }
          this.e1 = 2;
          const allowedKeys = [];
          this.stepOneResponse.keys = Object.filterByKey(
              allowedKeys,
              this.stepOneResponse.keys,
          );
        });
      }
    },
    // Aşama 2: whatsapp mesajı Gönder
    sendWhatsappS2() {
      if (this.$refs.stepTwo.validate()) {
        this.send({
          route: 'whatsapp/excel/send',
          data: this.prepareOriginal(),
          headers: { 'Content-Type': 'multipart/form-data' },
          method: 'POST',
        }).then(() => {
          this.resetForm();
        });
      }
    },
    handleTextChange(val) {
      this.message = val || '';

      const keys = this.stepOneResponse.exampleValues;

      let dumpPreview = this.message;
      if (dumpPreview) {
        Object.keys(keys).forEach((exVal) => {
          dumpPreview = dumpPreview.replace(`|${exVal}|`, keys[exVal]);
        });
      }

      this.preview = dumpPreview;
    },
    whatsappPreview() {
      if (this.confirmation.valid) {
        this.confirmation.valid = false;
        this.$trigger('setPluginDialog');
      }
      this.confirmation.valid = this.$refs.stepTwo.validate();
      if (this.$refs.stepTwo.validate()) {
        this.send({
          route: 'whatsapp/excel/send/preview',
          data: this.prepareOriginal(),
          headers: { 'Content-Type': 'multipart/form-data' },
          method: 'POST',
        }).then((res) => {
          this.confirmation.context = res.data.data;
        });
      }
    },
    prepareOriginal() {
      this.sendData.excel = this.stepOneResponse.file;
      const form = new FormData();
      form.append('excel', this.sendData.excel);
      form.append('bridge', this.sendData.bridge);
      form.append('phone_colon', this.sendData.phone_colon);
      form.append('sender', this.sendData.sender);
      form.append('attachment', this.attachment);
      form.append('delay', this.delay);
      form.append('message', this.message);
      return form;
    },
  },
  created() {
    this.defaultLink = (this.isVatan
            ? 'vatansms.net'
            : 'toplusmspaketleri.com') + this.defaultLink;
    this.sendData.bridge = this.isVatan
        ? 'vatansms.net'
        : 'toplusmspaketleri.com';
    this.delay = this.delayOptions.find(option => option.text === "Çok Hızlı (5 saniye de bir)").value;
    Vue.axios({
          url: `${this.$store.getters.apiEndpoint}whatsapp/check-device-active`,
          data: {},
          method: 'POST',
          statusCode: 500,
          responseType: 'JSON',
        }).then((res) => {
          this.whatsappStatus = res.data.data.device || res.data.data.other_devices && res.data.data.account_status;
        });
  },
  computed: {
    eHeaders() {
      const rHeaders = [];
      Object.entries(this.stepOneResponse.headers).forEach((v) => {
        rHeaders.push({
          k: v[0],
          v: v[1],
        });
      });
      return rHeaders;
    },
  },
};
</script>
